import React from 'react';

export default (upload, name) => (dispatch, getState) => {

  dispatch({ type: 'LOADING_TYPEAHEAD' });

  const { token, complianceText, loadExamplePortfolio, wtRegion } = getState();
  const tickers = upload.map(o => o[upload.columns[0]].trim());
  const weights = upload.map(o => o[upload.columns[1]].toString().trim());

  const resultsToPortfolio = results => ({
    name: name,
    holdings: [{
      names: results.map(o => o.name),
      types: results.map(o => o.type),
      tickers: results.map(o => o.ticker),
      weights: results.map(o => o.weight),
    }]
  })

  const loadPortfolio = foundResults => {
    dispatch({ 
      type: 'LOAD_PORTFOLIO',
      portfolio: resultsToPortfolio(foundResults)
    })
  }

  // Set up the request body with tickers and region
  const requestBody = {
    tickers: tickers,
    wtRegion: wtRegion,
  };

  fetch(`${process.env.REACT_APP_API_URL}/securityfund/ticker_names/`, {
    method: 'POST',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json',
      Authorization: token &&
        `Token ${token}`,
    },
  })
    .then(d => d.json())
    .then(data => {
      
      dispatch({ type: 'LOADED_TYPEAHEAD' });

      let results = [[], []];
      data.tickers.forEach((ticker,i) => {
        const row = {
          ticker,
          name: data.names[i],
          type: data.types[i],
          weight: weights[i].includes("%")
            ? 1e6 * (+weights[i].replace(/[^0-9.-]+/g,"") / 100)
            : +weights[i].replace(/[^0-9.-]+/g,""),
        }
        results[+(row.name !== "UNKNOWN")].push(row);
      })

      const messageNotFound = results[0].length
        ? (<div>
          {complianceText.tickersNotRecognizedUpload}
          <span className="error-red"> {results[0].map(o => o.ticker).join(", ")}</span>
        </div>)
        : '';
      const tickersWithoutWeight = results[1].filter(o => o.weight <= 0)
      const messageNoWeight = tickersWithoutWeight.length
        ? (<div>
          {complianceText.noWeightingFoundUpload}
          <span className="error-red">{tickersWithoutWeight.map(o => o.ticker).join(", ")}</span>
        </div>)
        : '';

      if(tickersWithoutWeight.length === results[1].length){
        results[1].forEach((e,i,a) => {
          results[1][i] = { ...e, weight: 1e6 / a.length }
        })
      }

      if(messageNotFound || messageNoWeight){
        dispatch({
          type: 'DIALOG',
          message: <div>{messageNotFound}{messageNoWeight}</div>,
          buttons: [
            { label: 'Cancel' },
            { label: 'Continue', callback: () => {
              loadPortfolio(results[1])
            }},
          ],
        })
      } else {      
        loadPortfolio(results[1])
      }

      if (loadExamplePortfolio){
        // if window.portfolioMapper has examplePortfolio, make it the default
        dispatch({ 
          type: 'SET_DEFAULT_PORTFOLIO', 
          portfolio: resultsToPortfolio(results[1]) 
        })
      }

    })
    .catch(error => {
      console.error(error);
    });
};


// WEBPACK FOOTER //
// ./src/actions/query-api/ticker-names.js